// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hand .Playing-card{
	position:absolute;
	/*padding-top: 250px;*/
	margin-left: 250px;
}


`, "",{"version":3,"sources":["webpack://./reactjs/react-playing-cards-local/src/PlayingCard/Hand/Hand.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;AACnB","sourcesContent":[".Hand .Playing-card{\n\tposition:absolute;\n\t/*padding-top: 250px;*/\n\tmargin-left: 250px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
